import { Location } from '@angular/common';
import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ApplicationService } from '@app/core/services/application/application.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { faExclamationCircle, faPhone, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faPennant } from '@fortawesome/pro-solid-svg-icons';
import { NavController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-mobile-customer-actions',
    templateUrl: './application-quick-actions-mobile.component.html',
    styleUrls: ['./application-quick-actions-mobile.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationQuickActionsMobileComponent implements OnInit {
    @Input() application?: any;
    @Input() content?: any;
    @Input() program?: any;

    icons: any = {
        question: faQuestionCircle,
        phone: faPhone,
        exclamation: faExclamationCircle,
        pennant: faPennant,
    };

    programDetails: boolean;
    applicationDetails: boolean;

    hasApplication = false;

    favorite: any[] = [];

    constructor(
        public toolService: ToolService,
        private modalService: ModalService,
        private applicationService: ApplicationService,
        private location: Location,
        private navCtrl: NavController
    ) {}

    ngOnInit() {
        if (this.application !== undefined && this.application !== null) {
            if (Object.keys(this.application).length > 0 && this.application.constructor === Object) {
                this.programDetails = true;
                this.applicationDetails = false;
                this.hasApplication =
                    this.application.states === 'Pending' ||
                    this.application.states === 'Accepted' ||
                    this.application.states === 'Pre-Approved' ||
                    this.application.states === 'Pending-Booked'
                        ? true
                        : false;
            }
        }
    }

    cancelApplication(applicationId: string) {
        this.modalService
            .confirmation({
                title: 'Cancel Application',
                message: `
      You are about to cancel your application for \n\n
      ${this.application.specialty}, \n\n
      ${this.application.name} \n\n
      `,
                buttonText: `Yes, cancel this application.`,
                buttonColor: 'danger',
            })
            .then((result: any) => {
                if (result.data.confirmed) {
                    this.applicationService.cancelApplication(applicationId).subscribe((res: any) => {
                        this.location.replaceState('/dashboard');
                        this.navCtrl.navigateRoot(['/dashboard']);
                        location.reload();
                    });
                }
            })
            .catch((err: any) => {
                this.location.replaceState('/dashboard');
                this.navCtrl.navigateRoot(['/dashboard']);
            });
    }
}
